<template>
  <v-dialog v-model="mostra" max-width="360">
    <v-card>
      <v-card-title class="text-h6">
        {{ titulo }}
      </v-card-title>

      <v-card-text>
        <slot>
          {{ mensagem }}
        </slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="cancelar">
          Não
        </v-btn>
        <v-btn color="primary" text @click="confirmar">
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
	titulo?: string,
	mensagem?: string,
}>()

const mostra = ref(false)
const titulo = ref(props.titulo || 'Confirmação')
const mensagem = ref(props.mensagem || 'Tem certeza que deseja continuar?')

const resolver = ref<((value: boolean) => void) | null>(null)

const confirmar = () => {
  mostra.value = false
  resolver.value?.(true)
}

const cancelar = () => {
  mostra.value = false
  resolver.value?.(false)
}

const abrir = (config: { titulo?: string; mensagem?: string } = {}) => {
  if (config.titulo) titulo.value = config.titulo
  if (config.mensagem) mensagem.value = config.mensagem

  mostra.value = true

  return new Promise<boolean>((resolve) => {
    resolver.value = resolve
  })
}

defineExpose({ abrir })
</script>
